import { motion, AnimatePresence } from 'framer-motion';
import { FaTruck } from 'react-icons/fa';
import './Loader.css';

export default function Loader({ loading }) {
  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          className="loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.p
            className="loader__text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            {/* Ambadykannan<em>Transport</em> */}
            <img src="/assets/amlogo.jpeg" alt="Ambadykannan Transport Logo" className="loader__logo-image" />
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
